export const SECTION_IDS = ["hero", "about", "experience", "skills", "projects", "education", "contact"];

export const FILE_NAMES = {
  tr: {
    hero: "index.html",
    about: "hakkimda.md",
    experience: "deneyim.json",
    skills: "yetenekler.config.js",
    projects: "projeler.jsx",
    education: "egitim.txt",
    contact: "iletisim.env",
  },
  en: {
    hero: "index.html",
    about: "about.md",
    experience: "experience.json",
    skills: "skills.config.js",
    projects: "projects.jsx",
    education: "education.txt",
    contact: "contact.env",
  },
};

export const scrollToSection = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};
